import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LeadForm from "./components/LeadForm";
import Success from "./components/Success";
import "./base.css";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <main className="site">
              {/* NAV FIXE */}
              <nav className="topnav" role="navigation" aria-label="Navigation principale">
                <div className="container topnav__inner">
                  <a href="/" className="topnav__brand" aria-label="Accueil Blackout Games">
                    <img src="/logoblackout.jpg" alt="Blackout Games" className="topnav__logo" />
                  </a>
                </div>
              </nav>

              {/* HERO plein écran (sous la nav) */}
              <header className="hero">
                <div className="container hero__inner">
                  {/* Bloc titre/CTA sur toute la largeur */}
                  <div className="hero__copy hero__copy--full">
                    <h1 className="hero__title">
                      Escape games digitaux pour entreprises
                    </h1>

                    <h2 className="hero__subtitle">Des expériences collaboratives conçues pour renforcer la cohésion d’équipe, sans contrainte technique</h2>

                    <a href="#pilot" className="btn btn--primary">
                      Rejoindre la bêta
                    </a>

                    <p className="hero__fineprint">
                      Version courte (15–20 min, 2–3 énigmes). Nous vous recontactons
                      pour convenir d'un créneau.
                    </p>
                  </div>
                </div>

                {/* Bandeau fixé en bas du hero */}
                <div className="ribbon ribbon--in-hero">
                  <div className="container ribbon__grid">
                    <div className="ribbon__item">Aucune installation</div>
                    <div className="ribbon__dot">•</div>
                    <div className="ribbon__item">Accès sécurisés</div>
                    <div className="ribbon__dot">•</div>
                    <div className="ribbon__item">Dashboard de gestion</div>
                    <div className="ribbon__dot">•</div>
                    <div className="ribbon__item">Paiement sécurisé</div>
                    <div className="ribbon__dot">•</div>
                    <div className="ribbon__item">Facturation simple</div>
                    <div className="ribbon__dot">•</div>
                    <div className="ribbon__item">Pensé pour le remote</div>
                  </div>
                </div>
              </header>

              {/* 2) PILOTE + FORM */}
              <section className="section" id="pilot">
                <div className="container">
                  <div className="pilot">
                    <div className="infos_wrapper">
                      <div className="pilot__copy">
                        <h2 className="section__title">Programme pilote (gratuit)</h2>

                        <ul className="pilot__bullets">
                          <li>
                            Ouvert à 20 entreprises
                          </li>
                          <li>
                            2–3 énigmes du scénario <em>Projet Origami</em>
                          </li>
                          <li>Créneau prévu début 2026, en visio</li>
                          <li>Une session offerte (4-6 joueurs) au lancement pour les participants</li>
                        </ul>

                        <hr></hr>
                        <p className="muted">
                          Nous lançons une phase pilote gratuite ouverte à 20 entreprises partenaires avant le lancement officiel au printemps 2026.

L’objectif : tester l’expérience de jeu en conditions réelles (fluidité, ergonomie, synchronisation temps réel) et recueillir vos retours pour peaufiner le produit final.

Concrètement, il suffit de mobiliser une petite équipe (4 à 6 collaborateurs) pour une session d’environ une heure.

En remerciement de votre participation, vous recevrez une session complète offerte lors du lancement officiel.</p>
                        {/* <p className="muted">
                  Le but de la bêta est de valider la fluidité du jeu,
                  l’ergonomie, la synchronisation temps réel et de recueillir vos retours pour améliorer notre produit et vous proposer une expérience de qualité au lancement officiel. 
                </p> */}
                      </div>

                      {/* “Session démo” */}
                      <div className="hero__visual hero__visual--stack">
                        <div className="visual-card">
                          <div className="visual-card__badge">Session démo</div>
                          <div className="visual-card__title">PROJET ORIGAMI</div>
                          <ul className="visual-card__list">
                            <li>🔐 Accès par code</li>
                            <li>🧩 Énigmes synchronisées</li>
                            <li>⏱ Timer partagé</li>
                            <li>👥 4–6 joueurs</li>
                          </ul>
                          <div className="visual-card__foot">
                            Compatible Chrome/Edge/Firefox
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="pilot__form">
                      <div className="card card--form">
                        <LeadForm />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* 3) DIFFERENTIATORS */}
              <section className="section">
                <div className="container">
                  <h2 className="section__title">Pourquoi c’est différent ?</h2>
                  <div className="cards">
                    <article className="card">
                      <h3 className="card__title">Pensé pour la coopération</h3>
                      <p className="card__text">
                        Les indices sont dynamiquement répartis entre les joueurs, en fonction du nombre de joueurs. Impossible d’avancer
                        sans s’écouter et se coordonner.
                      </p>
                    </article>
                    <article className="card">
                      <h3 className="card__title">Plug & play</h3>
                      <p className="card__text">
                        Un lien, un code. Tout tourne dans le navigateur. Parfait pour
                        des équipes à distance et facile à utiliser.
                      </p>
                    </article>
                    <article className="card">
                      <h3 className="card__title">Pensé entreprise</h3>
                      <p className="card__text">
                        Inscription simple, achat et facturation sécurisés, gestion des sessions. Tout est pensé pour vous faciliter la vie. Le
                        fun, sans la logistique pénible.
                      </p>
                    </article>
                  </div>
                </div>
              </section>

              {/* 4) HOW IT WORKS */}
              <section className="section">
                <div className="container">
                  <h2 className="section__title">Comment ça marche</h2>
                  <ol className="steps">
                    <li className="steps__item">
                      <span className="steps__num">1</span>
                      Vous candidatez à la bêta en répondant au questionnaire ci-dessus.
                    </li>
                    {/* <li className="steps__item">
              <span className="steps__num">2</span>
              Nous améliorons notre produit en fonction de vos réponses et préparons la bêta.
            </li> */}
                    <li className="steps__item">
                      <span className="steps__num">2</span>
                      Nous définissons ensemble un créneau pour votre participation.
                    </li>
                    <li className="steps__item">
                      <span className="steps__num">3</span>
                      Nous vous fournissons un code d'accès.
                    </li>
                    <li className="steps__item">
                      <span className="steps__num">4</span>
                      Vous jouez 15–20 minutes avec 4–6 collègues.
                    </li>
                    <li className="steps__item">
                      <span className="steps__num">5</span>
                      Nous faisons un debrief rapide.
                    </li>
                    {/* <li className="steps__item">
              <span className="steps__num">7</span>
              Vous bénéficierez d'un tarif préférentiel pour la version complète à sa sortie.
            </li> */}
                  </ol>
                </div>
              </section>

              {/* 5) FAQ */}
              <section className="section">
                <div className="container">
                  <h2 className="section__title">FAQ rapide</h2>
                  <div className="faq">
                    <details className="faq__item">
                      <summary>Faut-il installer quelque chose ?</summary>
                      <p>
                        Non. Un navigateur moderne suffit. Idéalement
                        Chrome/Edge/Firefox à jour.
                      </p>
                    </details>
                    <details className="faq__item">
                      <summary>Des outils complémentaires sont-ils nécessaires pour jouer ?</summary>
                      <p>
                        Oui, une application de communication type Slack, Skype, Teams (...) permettant aux joueurs de parler en live est nécessaire. Aucun partage d'écran n'est nécessaire, chaque joueur dispose d'une partie de l'énigme, comme s'il était dans sa propre salle.
                      </p>
                    </details>
                    <details className="faq__item">
                      <summary>Combien de joueurs peuvent participer ?</summary>
                      <p>4 à 6 joueurs par session. La bêta et les jeux sont optimisés pour ces formats.</p>
                    </details>
                    <details className="faq__item">
                      <summary>Combien de temps dure une session ?</summary>
                      <p>La bêta durera 15 à 20 min. La version complète durera entre 60 et 90 min.</p>
                    </details>
                    <details className="faq__item">
                      <summary>Est-ce jouable sur téléphone ?</summary>
                      <p>Non, nos énigmes sont adaptées à des plateformes web en mode desktop. La qualité et la visibilité seraient insuffisantes en version mobile.</p>
                    </details>
                  </div>
                </div>
              </section>

              {/* FOOTER */}


              <footer className="footer">
                              <p class="container footer__rgpd">
  Les informations recueillies via ce site sont traitées par Blackout Games uniquement dans le cadre du programme pilote. 
  Elles ne sont ni partagées ni revendues. 
  Pour toute demande de suppression de vos données, contactez &nbsp;  
  <a href="mailto:blackoutgames.fr@gmail.com">blackoutgames.fr@gmail.com</a>.
</p>
                <div className="container footer__inner">
                  <p>© {new Date().getFullYear()} Blackout Games</p>
                  <a className="footer__link" href="mailto:blackoutgames.fr@gmail.com">
                    blackoutgames.fr@gmail.com
                  </a>
                </div>
              </footer>
            </main>
          }
        />
        <Route path="/success" element={<Success />} />
      </Routes>
    </BrowserRouter>
  );
}
